var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "", "ma-0": "" } },
    [
      _c("strong", { staticClass: "black--text" }, [
        _vm._v(_vm._s(_vm.attribute.name))
      ]),
      _vm._v(" "),
      _c("v-layout", { attrs: { "ma-0": "" } }, [
        _c("label", { staticClass: "grey--text sub-title--text" }, [
          _vm._v("\n      " + _vm._s(_vm.coValue) + "\n    ")
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "ml-1 italic--text grey--text" }, [
          _vm._v(_vm._s(_vm.attribute.unit))
        ])
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-153bb4f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-153bb4f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/attribute-label-value/template.html
// module id = null
// module chunks = 